import React, { useMemo } from "react";

import {
  getCountryByCountryCode,
  getDefaultCountry,
  getPhoneInputCountries,
  toIsdSelectOptions,
} from "constants/countryConfig";
import { getPhoneConfigForIsd } from "constants/phoneConfig";
import SingleSelect from "../Dropdown/SingleSelect";
import Textfield from "../Textfield/Textfield";

import styles from "./PhoneWithIsdInput.module.scss";

const PhoneWithIsdInput = ({
  phone,
  onPhoneChange,
  countryCode,
  onCountryCodeChange,
  phoneLabel = "Phone Number",
  disabled = false,
}) => {
  const phoneInputCountries = useMemo(() => getPhoneInputCountries(), []);
  const menuItems = useMemo(
    () => toIsdSelectOptions(phoneInputCountries),
    [phoneInputCountries],
  );
  const resolvedCountryCode =
    countryCode || getDefaultCountry()?.countryCode || "";
  const selectedCountry = getCountryByCountryCode(resolvedCountryCode);
  const phoneConfig = getPhoneConfigForIsd(selectedCountry?.isdCode);

  return (
    <div className={styles.container}>
      <div className={styles.isdSelect}>
        <SingleSelect
          id="country-isd-select"
          name="countryCode"
          placeholder={selectedCountry?.isdCode || "+91"}
          value={resolvedCountryCode}
          menuItems={menuItems}
          handleChange={(event) => onCountryCodeChange(event.target.value)}
          disabled={disabled || !menuItems.length}
        />
      </div>
      <div className={styles.phoneField}>
        <Textfield
          label={phoneLabel}
          fullWidth
          margin="normal"
          value={phone}
          disabled={disabled}
          onChange={(event) => {
            const digitsOnly = (event.target.value || "")
              .replace(/\D/g, "")
              .slice(0, phoneConfig.maxLength);
            onPhoneChange(digitsOnly);
          }}
        />
      </div>
    </div>
  );
};

export default PhoneWithIsdInput;
